// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReasonMLCommunity__ApolloClient from "./ReasonMLCommunity__ApolloClient.bs.js";

var make = ReasonMLCommunity__ApolloClient.make;

var DefaultWatchQueryOptions = ReasonMLCommunity__ApolloClient.DefaultWatchQueryOptions;

var DefaultQueryOptions = ReasonMLCommunity__ApolloClient.DefaultQueryOptions;

var DefaultMutateOptions = ReasonMLCommunity__ApolloClient.DefaultMutateOptions;

var DefaultOptions = ReasonMLCommunity__ApolloClient.DefaultOptions;

var React = ReasonMLCommunity__ApolloClient.React;

var Cache = ReasonMLCommunity__ApolloClient.Cache;

var Link = ReasonMLCommunity__ApolloClient.Link;

var Utilities = ReasonMLCommunity__ApolloClient.Utilities;

var Bindings = ReasonMLCommunity__ApolloClient.Bindings;

var GraphQL_PPX = ReasonMLCommunity__ApolloClient.GraphQL_PPX;

var Testing = ReasonMLCommunity__ApolloClient.Testing;

var Types = ReasonMLCommunity__ApolloClient.Types;

export {
  make ,
  DefaultWatchQueryOptions ,
  DefaultQueryOptions ,
  DefaultMutateOptions ,
  DefaultOptions ,
  React ,
  Cache ,
  Link ,
  Utilities ,
  Bindings ,
  GraphQL_PPX ,
  Testing ,
  Types ,
}
/* ReasonMLCommunity__ApolloClient Not a pure module */
